/* src/components/pages/Crearpagos.jsx - Modificado el 18-03-2026 */
/* ------------- crea nómina de pago de FA Deudor -------------- */

import React, {
  useState,
  useEffect,
  useCallback
} from 'react';

import {
  TextField,
  Typography,
  Divider,
  MenuItem,
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  FormControl,
  Checkbox,
  InputLabel,
  Select,
  Stack,
  Card,
  CardContent,
  CardHeader
} from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

import { normalizeRut } from "../utils/rutUtils";
import { formatFecha } from "../utils/dateUtils";
import { formatoCLP } from "../utils/montoclpUtils";

import {
  RiSave3Fill,
  RiFileList2Fill,
  RiReplyAllFill,
  RiFileCopy2Fill,
  RiSlackFill,
  RiFilePdf2Fill
} from "react-icons/ri";

import * as XLSX from 'xlsx';

const Crearpagos = ({ modo }) => {
  const { user } = useAuth();

  const [datacesiones, setCesiones] = useState([]);
  const [loading, setLoading] = useState(false);

  const [idban, setIdban] = useState(0);
  const [bancos, setBancos] = useState([]);

  const fechaActual = new Date();
  const anoCan = fechaActual.getFullYear();
  const mesCan = fechaActual.getMonth() + 1; // Sumamos 1 para obtener el valor numérico del mes

  const [openDialog, setOpenDialog] = useState(false);
  const [rowDetails, setRowDetails] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]); // Estado para las filas seleccionadas
  const [selectedRowsData, setSelectedRowsData] = useState([]); // Datos de las filas seleccionadas
  const [totalMonto, setTotalMonto] = useState(0); // Total monto de las filas seleccionadas

  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  /* Estados para paginación desde el servidor */
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [rowCount, setRowCount] = useState(0);

   /* Totales de Cesiones */
  const [totalMontoCes, setTotalMontoCes] = useState(0);
  const [totalMontoDte, setTotalMontoDte] = useState(0);
  const [cantidadCesiones, setCantidadCesiones] = useState(0);

  const handleSelectRow = (event, rowId) => {
    if (event.target.checked) {
      setSelectedRows((prev) => {
        // Añadir la fila al estado si no existe ya
        if (!prev.includes(rowId)) {
          return [...prev, rowId];
        }
        return prev;
      });
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== rowId));
    }
  };

  // calculo filas seleccionadas //
  useEffect(() => {
    const selectedData = datacesiones.filter((row) =>
      selectedRows.includes(row.id)
    );

    setSelectedRowsData(selectedData);

    const total = selectedData.reduce((sum, row) => sum + (row.montoces || 0), 0);
    setTotalMonto(total);
  }, [selectedRows, datacesiones]);

  // Función para cancelar y limpiar los arreglos //
  const handleCancel = () => {
    setCesiones([]);
    setSelectedRows([]);
    setTotalMonto(0);
    setIdban(0);
    setRowCount(0);
   };
  
  // Manejo cambio de banco //
  const handleSelectChange = (e) => {
    const selectedId = e.target.value;

    // 1. Estado base
    setIdban(selectedId);

    // 2. Reset controlado (UX consistente)
    setPage(0);
    setSelectedRows([]);
    setSelectedRowsData([]);
    setTotalMonto(0);

    // 3. Limpiar grilla antes de nueva búsqueda
    setCesiones([]);
    setRowCount(0);

    // 4. Ejecutar búsqueda SOLO si hay banco válido
    setIdban(selectedId);

    setTimeout(() => {
      fetchCesiones({
        page: 0,
        pageSize,
        showMsg: true,
        idbanParam: selectedId,
      });
    }, 0);
  };

  /* generar excel final */
  const generarExcel = () => {
    const dataForExcel = selectedRowsData.map((row) => ({
      'Rut Cesionario': row.rutcesionario,
      'Razón Social': row.nomcesionario,
      'Tipo DTE': row.tipodte,
      'Folio': row.folio,
      'Fecha Emisión': formatFecha(row.fecemi),
      'Monto Cesión': row.montoces,
      'Banco': row.idban,
      'Nombre': row.nomban,
      'Cuenta': row.ctacte,
    }));

    const ws = XLSX.utils.json_to_sheet(dataForExcel);

    // Header PRO
    XLSX.utils.sheet_add_aoa(ws, [
      [`Comprobante de Pago - Banco ${idban}`],
      [`Fecha: ${new Date().toLocaleDateString()}`],
      [`Cantidad: ${selectedRows.length}`],
      [`Monto Total: ${formatoCLP(totalMonto)}`],
      []
    ], { origin: "A1" });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Nomina");

    const fileName = `Nomina_Pago_Bco_${idban}_${new Date().toISOString().split('T')[0]}.xlsx`;

    XLSX.writeFile(wb, fileName);
  };

  /* Grabar comprobante de pago */
  const saveSelectedData = async () => {
    if (selectedRows.length === 0) {
      showFeedback({
        message: "Seleccione al menos un registro",
        severity: "warning",
      });
      return;
    }

    try {
      const rutCan = user.usuario.padStart(10, '0');

      const detalles = selectedRowsData.map((row) => ({
        idces: row.id,
        fecha: row.feccesion,
        uuid: row.uuid,
        tipo: row.tipo,
        rutdeudor: row.rutdeudor,
        rutcedente: row.rutcedente,
        rutcesionario: row.rutcesionario,
        feccesion: row.feccesion,
        montoces: row.montoces,
        rutemisor: row.rutemisor,
        tipodte: row.tipodte,
        folio: row.folio,
        fecemi: row.fecemi,
        montodte: row.montodte,
        banco: row.idban,
        ctacte: row.ctacte,
      }));

      const responsePagos = await api.post("/pagos/addpagos", {
        rutcan: rutCan,
        anocan: anoCan,
        mescan: mesCan,
        cantidad: selectedRows.length,
        monto: totalMonto,
        banco: idban,
        detalles,
      });

      if (responsePagos.data?.success) {
        showFeedback({
          message: "Comprobante generado correctamente",
          severity: "success",
        });

        // 🔥 Export Excel (OK mantener en frontend)
        generarExcel();

        // Reset limpio
        handleCancel();
      } else {
        throw new Error();
      }

    } catch {
      showFeedback({
        message: "Error al generar el comprobante",
        severity: "error",
      });
    }
  };


  // cargar bancos desde cecisones pendientes de pago //
  const fetchBancos = useCallback(async () => {
    try {
      const RutCli = user.usuario.padStart(10, '0');
  
      const response = await api.post("/cesiones/getbancoscesiones",
        { RutCli },
      );

      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows); // Asigna los datos al estado //
      } else {
        setBancos([]); // Si no hay datos, asegúrate de limpiar el estado //
      }

    } catch (error) {
      setBancos([]); // Si no hay datos, asegúrate de limpiar el estado //
    }
  }, [user]);

  // carga los bancos //
  useEffect(() => {
    fetchBancos();
  }, [fetchBancos]);


  /* Función para obtener los datos. recibe la página solicitada */
  const fetchCesiones = useCallback(async ({
      page = 0,
      pageSize = 20,
      showMsg = false,
      idbanParam,
    } = {}) => {

      const banco = idbanParam ?? idban;

      if (!user.usuario || banco === 0) return;

    setLoading(true);

    try {
      const RutCli = normalizeRut(user.usuario);

      const response = await api.post("/cesiones/getcesiones", {
        RutCli,
        Tipo: 'DEUDOR',
        Estadosel: 0,
        Anoaconsultar: 0,
        Mesaconsultar: 0,
        Idban: banco,
        page,
        pageSize,
      });

      if (response.data.success) {
        const { rows, totales, total } = response.data;

        setCesiones(rows);
        setRowCount(total);

        setTotalMontoCes(totales.montoces);
        setTotalMontoDte(totales.montodte);
        setCantidadCesiones(totales.cantidad);

        // SOLO en búsqueda manual
        if (showMsg && rows.length === 0) {
          showFeedback({
            message: "No se encontraron registros",
            severity: "info",
          });
        }

      } else {
        setCesiones([]);
        setRowCount(0);

        if (showMsg) {
          showFeedback({
            message: "No se encontraron registros",
            severity: "info",
          });
        }
      }

    } catch {
      showFeedback({
        message: "Error al obtener datos",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [user, idban, showFeedback]);

  // Mostrar los detalles de la fila seleccionada //
  const handleRowClick = (row) => {
    setRowDetails(row);
    setOpenDialog(true);  // Abrir el diálogo con los detalles //
  };

  /* Configuración de MUI DataGrid */
  const columns = [
    {
      field: "select",
      headerName: "Sel",
      width: 70,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

      renderCell: (params) => {
        const pagada = params.row.pagada;

        return (
          <Checkbox
            checked={selectedRows.includes(params.id)}
            onChange={(e) => handleSelectRow(e, params.id)}
            disabled={pagada === 1}
            size="small"
            sx={{
              p: 0,
              color: (theme) => theme.custom.ui.checkboxColor,

              '&.Mui-checked': {
                color: (theme) => theme.custom.ui.checkboxChecked,
              },

              '&.Mui-disabled': {
                color: (theme) => theme.custom.ui.disabledText,
              },
            }}
          />
        );
      },
    },
    {
      field: "pagada",
      headerName: "Estado",
      width: 130,
      headerAlign: "center",
      align: "center",
      sortable: true,

      renderCell: (params) => {
        const pagada = params.value;

        let variant;
        let label;

        if (pagada === 0) {
          variant = "warning";   // Pendiente
          label = "Pendiente";
        } else if (pagada === 1) {
          variant = "success";   // En nómina (flujo OK)
          label = "En Nómina";
        } else if (pagada === 2) {
          variant = "paid";   // Pagada
          label = "Pagada";
        }

        if (!variant) return null;

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={(theme) => {
                const status = theme.custom.ui.status?.[variant];

                return {
                  backgroundColor: status?.bg,
                  color: status?.text,
                  border: `1px solid ${status?.border}`,

                  padding: "5px 10px",
                  borderRadius: "5px",
                  minWidth: 110,
                  height: 22,

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                };
              }}
            >
              {label}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 50,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,

      renderCell: (params) => {
        const { uuid } = params.row;

        const handleOpenPDF = async () => {
          if (!uuid) return;

          try {
            const response = await api.post('/cesiones/getcesionespdf',
              { uuid },
              { responseType: 'blob' }
            );

            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf',
            });

            const url = window.URL.createObjectURL(pdfBlob);
            window.open(url, '_blank');

            setTimeout(() => {
              window.URL.revokeObjectURL(url);
            }, 1000);

          } catch (error) {
            showFeedback({
              message: 'No fue posible obtener el Pdf',
              severity: 'error',
            });
          }
        };

        return (
          <Button
            variant="contained"
            aria-label="Abrir PDF"
            onClick={handleOpenPDF}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              minWidth: 0,
              padding: 0,
              width: 32,
              height: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.primaryActionHover,
              },
            }}
          >
            <RiFilePdf2Fill size={20} />
          </Button>
        );
      },
    },
    {
      field: 'detalle',
      headerName: "Info",
      width: 70,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => handleRowClick(params.row)}
          sx={{
            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,
            minWidth: 0,
            padding: 0,
            width: 32,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.primaryActionHover,
            },
          }}
        >
          <RiFileList2Fill size={22} />
        </Button>
      ),
    },
    {
      field: "folionc",
      headerName: "NC",
      width: 70,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.value > 0 ? (
          <Tooltip title={`Número NC: ${params.value}`} arrow>
            <span>
              <RiFileCopy2Fill size={22} color="red" />
            </span>
          </Tooltip>
        ) : null,
    },
    {
      field: 'feccesion',
      headerName: 'Fecha Ces.',
      width: 140,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montoces',
      headerName: "Monto Ces.",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return formatoCLP(params.value);
      },
    },
    {
      field: 'fecrec',
      headerName: 'Recepción',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'dias_reclamo',
      headerName: 'Días Reclamo',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      sortable: true,

      renderCell: (params) => {
        const dias = params.value;

        if (dias === null || dias === undefined) {
          return (
            <Box sx={{ fontSize: '0.75rem', opacity: 0.5 }}>
              -
            </Box>
          );
        }

        let variant = 'success';
        let label = 'OK';

        if (dias <= 0) {
          variant = 'error';
          label = 'Vencido';
        } else if (dias <= 3) {
          variant = 'warning';
          label = 'Urgente';
        }

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={(theme) => {
                const status = theme.custom.ui.status?.[variant];

                return {
                  backgroundColor: status?.bg,
                  color: status?.text,
                  border: `1px solid ${status?.border}`,
                  padding: "5px 10px",
                  borderRadius: "5px",
                  minWidth: 110,
                  height: 22,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                };
              }}
            >
              {dias} · {label}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'rutcedente',
      headerName: "Cedente",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomcedente',
      headerName: "Razón Social",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'rutcesionario',
      headerName: "Cesionario",
      width: 130,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomcesionario',
      headerName: "Razón Social",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'tipodte',
      headerName: "Dte",
      width: 350,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'folio',
      headerName: "Folio",
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'fecemi',
      headerName: "Fecha Emisión",
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montodte',
      headerName: "Monto",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return formatoCLP(params.value);
      },
    },
    {
      field: 'idban',
      headerName: 'Banco',
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'nomban',
      headerName: 'Nombre',
      width: 300,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'ctacte',
      headerName: 'Ctacte',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  /* Render */
  return (
    <Box
      sx={{
        width: '100%',
        pt: 0,
        overflow: 'visible'
      }}
    >
      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        {/* Rut */}
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Nombre */}
        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Banco */}
        <FormControl fullWidth required sx={{ width: '300px' }}>
          <InputLabel id="banco-label" sx={{ marginTop: '2px' }}>Banco</InputLabel>
          <Select
            labelId="banco-label"
            id="banco-select"
            value={idban}
            label="Banco"
            onChange={handleSelectChange} // Llamamos a la función que maneja el cambio
            sx={{
              height: '40px', // Altura del TextField
              '& .MuiOutlinedInput-root': { height: '40px' },
              '& .MuiSelect-select': { textAlign: 'center' }
            }}
            >
            <MenuItem value={0}>✨ Seleccionar Banco</MenuItem>
            {bancos.map((banco) => (
              <MenuItem key={banco.idban} value={banco.idban}>
                {banco.nomban}
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        {/* Botón Cancelar */}
        <Tooltip title="Cancelar Todo" placement="top" arrow>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: 130,
              height: 40,
              textTransform: 'none',

              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,

              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },

              '&.Mui-disabled': {
                backgroundColor: (theme) =>
                  theme.custom.ui.disabledBg,
                color: (theme) =>
                  theme.custom.ui.disabledText,
              },
            }}
            startIcon={<RiReplyAllFill size={18} />}
          >
            Cancelar
          </Button>
        </Tooltip>



        {/* Botón Grabar Comprobante */}
        <Tooltip title="Grabar Pagos" placement="top" arrow>
          <span>
            <Button
              variant="contained"
              onClick={saveSelectedData}
              disabled={!idban || selectedRows.length === 0}
              sx={{
                width: 130,
                height: 40,
                textTransform: 'none',

                backgroundColor: (theme) => theme.custom.ui.primaryAction,
                color: (theme) => theme.custom.ui.primaryActionText,

                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.custom.ui.primaryActionHover,
                },

                '&.Mui-disabled': {
                  backgroundColor: (theme) =>
                    theme.custom.ui.disabledBg,
                  color: (theme) =>
                    theme.custom.ui.disabledText,
                },
              }}
              startIcon={<RiSave3Fill size={18} />}
            >
              Grabar
            </Button>
          </span>
        </Tooltip>

      </Stack>


      {/* Cards de Totales */}
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="flex-start"
        gap={1}   // espacio horizontal y vertical
        sx={{ mt: 1, mb: 1 }}
      >
        {/* CARD 1 - Cantidad de Cesiones */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Cesiones
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {cantidadCesiones}
            </Typography>
          </Box>
        </Card>

        {/* CARD 2 - Monto Cesiones */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Monto Cesiones
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMontoCes)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 3 - Monto Total */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Monto Dtes
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMontoDte)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 4 - Filas Seleccionadas */}
        <Card
          sx={(theme) => ({
            width: 130,
            minHeight: 52,
            backgroundColor: theme.custom.ui.surfaceBg, // 👈 mismo fondo
            borderRadius: 2,
            boxShadow: theme.custom.ui.surfaceShadow,
            display: 'flex',

            // 👇 diferenciador elegante
            border: `1px solid ${theme.custom.ui.brandAccent}`,
          })}
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent,
                fontSize: '0.75rem',
                fontWeight: 600,
                letterSpacing: '0.02em',
              }}
            >
              Seleccionadas
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {selectedRows.length}
            </Typography>
          </Box>
        </Card>

        {/* CARD 5 - Monto DTE Seleccionado */}
        <Card
          sx={(theme) => ({
            width: 130,
            minHeight: 52,
            backgroundColor: theme.custom.ui.surfaceBg, // 👈 mismo fondo
            borderRadius: 2,
            boxShadow: theme.custom.ui.surfaceShadow,
            display: 'flex',

            // 👇 diferenciador elegante
            border: `1px solid ${theme.custom.ui.brandAccent}`,
          })}
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent,
                fontSize: '0.75rem',
                fontWeight: 600,
                letterSpacing: '0.02em',
              }}
            >
              Monto Selecc.
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMonto)}
            </Typography>
          </Box>
        </Card>

      </Stack>

      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 270px)', // ajusta según tu layout
          minHeight: 0,
        }}
       >
        <DataGrid
          rows={datacesiones}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          paginationMode="server"
          rowCount={rowCount}
          pageSizeOptions={[10, 20, 50, 100]}
          paginationModel={{ page, pageSize }}

          onPaginationModelChange={({ page: newPage, pageSize: newPageSize }) => {
            const isPageSizeChange = newPageSize !== pageSize;
            const finalPage = isPageSizeChange ? 0 : newPage;

            setPage(finalPage);
            setPageSize(newPageSize);

            fetchCesiones({
              page: finalPage,
              pageSize: newPageSize,
              showMsg: false, // 🔥 CLAVE
            });
          }}

          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
            noRowsOverlay: () => (
              <Box sx={{ p: 2, textAlign: "center", opacity: 0.6 }}>
                {idban === 0
                  ? "Seleccione un banco para ver las cesiones"
                  : "Este banco no tiene cesiones pendientes"}
              </Box>
            ),
           }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      // scroll horizontal cuando corresponde
            border: 'none',
            // accesibilidad / foco
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {rowCount.toLocaleString('es-CL')} registros encontrados
      </Typography>

      {/* Dialog para mostrar los detalles de la fila */}
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        aria-labelledby="cesion-detalle-title"
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 8,
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
              border: `1px solid ${theme.custom.ui.borderSubtle}`,
            }),
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          id="cesion-detalle-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <RiSlackFill
              size={22}
              color="inherit"
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: (theme) => theme.custom.ui.brandAccent,
              }}
            >
              Detalles de la Cesión
            </Typography>
          </Stack>

          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.secondaryActionBg,
              color: (theme) =>
                theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cerrar
          </Button>
        </DialogTitle>

        <Divider
          sx={{
            borderColor: (theme) => theme.custom.ui.borderSubtle,
            opacity: 0.9,
          }}
        />

        {/* CONTENIDO */}
        <DialogContent
          sx={{
            maxHeight: '75vh',
            overflowY: 'auto',
            px: 2,
            py: 2,
          }}
        >
          {rowDetails && (
            <Stack spacing={3}>
              {/* Datos del Contribuyente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos del la Cesión"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />
                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Id Cesión', rowDetails.id],
                    ['Fecha Cesión', rowDetails.feccesion],
                    ['Rut Deudor', rowDetails.rutdeudor],
                    ['Razón Social', rowDetails.nomdeudor],
                    ['Dirección', rowDetails.domdeudor],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos del Cedente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cedente"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cedente', rowDetails.rutcedente],
                    ['Razón Social', rowDetails.nomcedente],
                    ['Dirección', rowDetails.domcedente],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos del Cesionario */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cesionario"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cesionario', rowDetails.rutcesionario],
                    ['Razón Social', rowDetails.nomcesionario],
                    ['Dirección', rowDetails.domcesionario],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos Nota de Crédito */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Nota Crédito"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Folio Nota Crédito', rowDetails.folionc],
                    ['Fecha Emisión', rowDetails.feceminc],
                    ['Monto', rowDetails.montonc],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos Estado de Pago */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) => theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Estado de Pago"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) => theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    [
                      'Estado',
                      rowDetails.pagada === 0
                        ? 'Pendiente'
                        : rowDetails.pagada === 1
                        ? 'En Nómina'
                        : 'Pagada'
                    ],
                    ['Comp. Pago Nro', rowDetails.idpago],
                    [
                      'Fecha de Pago',
                      rowDetails.fechapago
                        ? new Date(rowDetails.fechapago)
                            .toLocaleDateString('es-CL')
                        : '-'
                    ],
                    ['Cant. Documentos', rowDetails.cantidad],
                    ['Monto Total Comp', rowDetails.monto],
                    ['Conciliado', rowDetails.idpago],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Crearpagos;
